import { CaseloadHistoryCard } from './CaseloadHistoryCard'

export default CaseloadHistoryCard
